import { Stack, Typography } from '@mui/material';
import { Search } from '@components/shared/search/Search';
import { FLEXIBLE_REPORTING_TRIAL_TEXT } from '../../domain/text/flexible-reporting-trial-text';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { NewReportButton } from './NewReportButton';

type ActionBarProps = {
  campaignId: number;
  searchText: string;
  onSearch: (searchText: string) => void;
  disableNewReport: boolean;
};

export const ActionBar = (props: ActionBarProps) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography>{FLEXIBLE_REPORTING_TRIAL_TEXT}</Typography>
      <Stack
        direction="row"
        gap="0.5rem"
        alignItems="center"
        justifyContent="end"
      >
        <Search
          value={props.searchText}
          onChange={event => props.onSearch(event.target.value)}
          textFieldProps={{
            sx: { backgroundColor: unifiedPlatformColorPalette.white },
          }}
        />
        <NewReportButton
          campaignId={props.campaignId}
          disabled={props.disableNewReport}
        />
      </Stack>
    </Stack>
  );
};
